import React, { FunctionComponent, CSSProperties } from 'react';
import { Follow } from '../../molecules/follow';
import { RecruitmentShowContentFollow } from '../../molecules/recruitmentShowContentFollow';
import type { CompanyDetailHeadingProps } from './types';

type Props = CompanyDetailHeadingProps & {
  backgroundStyle: CSSProperties;
};

export const Presentation: FunctionComponent<Props> = ({
  company,
  iconImage,
  iconNoImg,
  coverImg,
  coverNoImg,
  noimage,
  hoverIcon,
  cancelIcon,
  user,
  companyId,
  isPc,
  isPage,
  isDisplayed,
  isStopped,
  isShow,
  isCompanyPage,
  dataCategory,
  dataValue,
  setIdCount,
  backgroundStyle,
  lineIcon,
  hasNoReleasedRecruitments
}) => {
  return (
    <>
      {isPc && (
        <div className="company-info-page-profile">
          <div className="company-info-page-profile-inner">
            <img
              className="company-info-page-profile-icon"
              src={iconImage || iconNoImg}
              alt={`${company.name}のロゴ写真`}
            />

            <div
              className="company-info-page-profile-right"
              id="company_id"
              data-company_id={company.id}
            >
              {!isShow ? (
                <h1 className="company-info-page-profile-name">{company.name}</h1>
              ) : (
                <p className="company-info-page-profile-name">{company.name}</p>
              )}

              <div className="company-info-page-profile-right-flex">
                <Follow
                  company_id={String(company.id)}
                  user={user}
                  className="company-info-page-profile-follow"
                  page="companyShow"
                  lineIcon={lineIcon}
                />

                <nav className="company-info-page-profile-right--menu gtm-navigation-view-count" data-event-name='navigation on screen' data-category={dataCategory} data-value={dataValue.selfNavigation}>
                  <a
                    className={isPage === 'show' && ('active' as any)}
                    href={`/companies/${company.id}`}
                    data-event="click"
                    data-category={dataCategory}
                    data-value={dataValue.selfNavigationHome}
                  >
                    ホーム
                  </a>
                  <a
                    className={isPage === 'recruitments' && ('active' as any)}
                    href={`/companies/${company.id}/recruitments`}
                    data-event="click"
                    data-category={dataCategory}
                    data-value={dataValue.selfNavigationRecruitments}
                  >
                    求人
                  </a>
                  <a
                    className={isPage === 'events' && ('active' as any)}
                    href={`/companies/${company.id}/events`}
                    data-event="click"
                    data-category={dataCategory}
                    data-value={dataValue.selfNavigationEvents}
                  >
                    イベント
                  </a>
                  <a
                    className={isPage === 'stories' && ('active' as any)}
                    href={`/companies/${company.id}/stories`}
                    data-event="click"
                    data-category={dataCategory}
                    data-value={dataValue.selfNavigationStories}
                  >
                    ストーリー
                  </a>
                </nav>
              </div>
              {hasNoReleasedRecruitments &&
                <p className='company-info-page-profile-stopped'>
                  ※現在募集終了（フォローで再開通知を受け取る）
                </p>
              }
            </div>
          </div>
        </div>
      )}

      {!isPc && (
        <div className="company__page__sp__heading">
          <div
            className="company__page__sp__heading--img"
            style={backgroundStyle}
          ></div>

          <div className="company__page__sp__heading__wrapper">
            <div className="company__page__sp__heading__wrapper__heading">
              <div className="company__page__sp__heading__wrapper__heading--icon">
                {iconImage ? (
                  <img src={iconImage} alt={`${company.name}のロゴ写真`} />
                ) : (
                  <img src={iconNoImg} alt={`${company.name}のロゴ写真`} />
                )}
              </div>

              <div className="company__page__sp__heading__wrapper__heading--follow">
                <Follow
                  company_id={String(company.id)}
                  user={user}
                  className="company-info-page-profile-follow"
                  page="companyShow"
                  lineIcon={lineIcon}
                />
              </div>
            </div>
            {hasNoReleasedRecruitments &&
              <p className='company-info-page-profile-stopped'>
                ※現在募集終了（フォローで再開通知を受け取る）
              </p>
            }
            <div className="company__page__sp__heading__wrapper__inner">
              <p>{company.name}</p>
            </div>
          </div>

          {isShow && isStopped && (
            <RecruitmentShowContentFollow
              companyId={companyId}
              user={user}
              noimage={coverNoImg}
              isDisplayed={isDisplayed}
              isShow={isShow}
              hoverIcon={hoverIcon}
              cancelIcon={cancelIcon}
              isCompanyPage={isCompanyPage}
              lineIcon={lineIcon}
            />
          )}

          <nav className="company__page__sp__heading__nav" id="spTop">
            <a
              className={isPage === 'show' && ('active' as any)}
              href={`/companies/${company.id}`}
              data-event="click"
              data-category={dataCategory}
              data-value={dataValue.selfNavigationHome}
            >
              ホーム
            </a>
            <a
              className={isPage === 'recruitments' && ('active' as any)}
              href={`/companies/${company.id}/recruitments#spTop`}
              data-event="click"
              data-category={dataCategory}
              data-value={dataValue.selfNavigationRecruitments}
            >
              求人
            </a>
            <a
              className={isPage === 'events' && ('active' as any)}
              href={`/companies/${company.id}/events#spTop`}
              data-event="click"
              data-category={dataCategory}
              data-value={dataValue.selfNavigationEvents}
            >
              イベント
            </a>
            <a
              className={isPage === 'stories' && ('active' as any)}
              href={`/companies/${company.id}/stories#spTop`}
              data-event="click"
              data-category={dataCategory}
              data-value={dataValue.selfNavigationStories}
            >
              ストーリー
            </a>
          </nav>
        </div>
      )}
    </>
  );
};
